import { Box, Grid } from '@material-ui/core';
import { useAuth } from '@nemuru-eng/providers';
import { Link, useLocation } from 'react-router-dom';

import { IconHeaderCard } from '@/components/shared/components/IconHeaderCard';
import { SectionTitle } from '@/components/shared/components/SectionTitle';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { CustomPalette } from '@/config/types';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const iconHeaderCardPaperProps = (palette: CustomPalette) => ({
  elevation: 0,
  border: false,
  fill: 'paper',
  style: {
    padding: 0,
    backgroundColor: 'transparent', //palette.grey[100],
    whiteSpace: 'break-spaces',
    borderRadius: 0, //customBorderRadius.paper,
    borderBottom: `1px solid ${palette.grey[200]}`,
    margin: 0,
  },
});

export const HomeShortcuts = () => {
  const {
    state: { currentLayout },
  } = useConfigContext();

  const { user } = useAuth();

  const location = useLocation();
  const { palette } = useCustomTheme();

  if (!currentLayout || !user) return null;

  const navSections = currentLayout?.navSections;
  if (!navSections.length) return null;

  const currentPath = location.pathname;

  return (
    <Box mt={8}>
      <SubSectionWrapper title="SHORTCUTS">
        <Grid container spacing={6}>
          {navSections
            ?.filter((section) => section.nameTextId)
            .map((section, i) => (
              <Grid item xs={12} sm={6} key={i} style={{ marginBottom: 12 }}>
                <SectionTitle
                  overline={''}
                  title={section.nameTextId ? <Text tId={section.nameTextId} /> : <Box height={'20px'} />}
                />
                <Box mt={3} display="flex" flexDirection="column" gridGap={0}>
                  {section.links.length &&
                    section.links.map(
                      (link, i) =>
                        currentPath !== link.path && (
                          <Link
                            key={i}
                            to={`${link.path}`}
                            style={{
                              display: 'block',
                              width: '100%',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            <IconHeaderCard
                              labelTid={currentLayout.pagesByPath[link.path]?.titleTextId || ''}
                              iconName={link.icon}
                              color={'minor'}
                              endIcon={'chevron_right'}
                              paperProps={iconHeaderCardPaperProps(palette)}
                              boxProps={{ padding: '8px 0 !important' }}
                            />
                          </Link>
                        ),
                    )}
                </Box>
              </Grid>
            ))}
        </Grid>
      </SubSectionWrapper>
    </Box>
  );
};
